import JdRankList from "../../components/JdRankList";
import Vue from 'vue'
$('#rankLink').hide()

if (window.rankList && window.rankList.rank_c) {
    console.log('start')
    new Vue({
        el: '#rankList',
        render: h => h(JdRankList, {
            props: {
                data: window.rankList.rank_c,
                additionalClass: 'gwd-w266'
            }
        })
    })
    $('#rankLink').attr('href', window.rankList.rank_c[0].rurl)
    $('#rankLink').css('display', 'inline-block')
} else {
}